export default __webpack_public_path__ + "static/media/clock.38a87d74.svg";